<template>
  <div class="device">
    <el-dialog
      :title="'设备新增'"
      :visible="visible"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="80%"
    >
      <el-form :model="formData" ref="formData" label-width="160px" :rules="rules">
        <el-form-item prop="name" label="设备名称" :rules="rules.requiredItem">
          <el-input v-model="formData.name" placeholder="请输入设备名称"></el-input>
        </el-form-item>
        <el-form-item prop="area" label="设备所在地" :rules="rules.requiredItem">
          <el-input v-model="formData.area" placeholder="请输入设备所在地"></el-input>
        </el-form-item>
        <el-form-item prop="room" label="所属机房" :rules="rules.requiredItem">
          <el-input v-model="formData.room" placeholder="请输入所属机房"></el-input>
        </el-form-item>
        <el-form-item label="网卡" :rules="rules.requiredItem">
          <el-collapse>
            <el-collapse-item v-for="(nc, index) in formData.networkCards" :key="index">
              <template slot="title">
                <span class="collapse-title">网卡{{index+1}}</span>

                <i class="el-icon-circle-plus titleIcon" @click="addCard"></i>
                <i
                  class="el-icon-delete-solid titleIcon"
                  @click="delCard(index)"
                  v-if="formData.networkCards.length > 1"
                ></i>

              </template>

              <div class="netset">
                <network-item ref="innerN" :networkItem.sync="nc.innerNetwork" title="内网"/>
              </div>

              <div class="netset">
                <div style="text-align: right;" v-if="!id">
                  <el-button type="primary" size="mini" @click="copy(nc, index)">一键复制</el-button>
                </div>
                <network-item ref="outerN" :networkItem.sync="nc.outerNetwork" title="外网"/>
              </div>
              <div class="portmap">
                <el-collapse>
                  <el-collapse-item>
                    <template slot="title">
                      <span class="collapse-title">端口映射</span>
                      <el-button v-if="!id" class="titleIcon" type="primary" size="mini" @click="automap(nc, index)">
                        重新映射
                      </el-button>
                    </template>
                    <div>
                      <el-form-item label-width="100px">
                        <port-map :networkCard="nc"/>
                      </el-form-item>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-form-item>

        <el-form-item label="设备状态">
          <el-col :span="8">
            <el-select v-model="formData.status">
              <el-option
                v-for="(option, index) in statusOption"
                :key="index"
                :label="option.label"
                :value="option.value"
              ></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="Agent-Deploy">
          <el-col :span="6">
            <el-select v-model="formData.deployIp" placeholder="请选择AgentDeployIP"
                       @change="selectIP('deploy')">
              <el-option
                v-for="(item, index) in filterAgentDeployIp"
                :key="index"
                :label="item.ip"
                :value="item.ip"
              ></el-option>
            </el-select>
          </el-col>
          <el-col align="center" :span="1">:</el-col>
          <el-col :span="6">
            <el-form-item prop="deployPort" :rules="rules.agentPort">
              <el-input v-model="formData.deployPort" placeholder="AgentDeploy端口"
                        @input="portInput('deploy')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="tips">
            {{validPort('deploy').tips}}
          </el-col>
          <el-col align="center" :span="2">
            <el-button type="primary" size="mini" @click="detect(formData.deployIp, formData.deployPort, 'deploy')">探测
            </el-button>
          </el-col>
          <el-col align="center" :span="2">
            <i class="el-icon-check" v-if="deployDetectResult == 1" style="color:#67C23A;font-size: 30px;"></i>
            <i class="el-icon-close" v-if="deployDetectResult == 0" style="color:#F56C6C;font-size: 30px;"></i>
          </el-col>
        </el-form-item>
        <el-form-item label="Agent-Exchange">
          <el-col :span="6">
            <el-select v-model="formData.exchangeIp" placeholder="请选择AgentExchangeIP"
                       @change="selectIP('exchange')">
              <el-option
                v-for="(item, index) in filterAgentDeployIp"
                :key="index"
                :label="item.ip"
                :value="item.ip"
              ></el-option>
            </el-select>
          </el-col>
          <el-col align="center" :span="1">:</el-col>
          <el-col :span="6">
            <el-form-item prop="exchangePort" :rules="rules.agentPort">
              <el-input v-model="formData.exchangePort" placeholder="agentExchangePort端口"
                        @input="portInput('exchange')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="tips">
            {{validPort('exchange').tips}}
          </el-col>
          <el-col align="center" :span="2">
            <el-button type="primary" size="mini"
                       @click="detect(formData.exchangeIp, formData.exchangePort, 'exchange')">探测
            </el-button>
          </el-col>
          <el-col align="center" :span="2">
            <i class="el-icon-check" v-if="exchangeDetectResult == 1" style="color:#67C23A;font-size: 30px;"></i>
            <i class="el-icon-close" v-if="exchangeDetectResult == 0" style="color:#F56C6C;font-size: 30px;"></i>
          </el-col>
        </el-form-item>
        <el-form-item label="Agent-Logs">
          <el-col :span="6">
            <el-select v-model="formData.logsIp" placeholder="请选择AgentLogsIP"
                       @change="selectIP('logs')">
              <el-option
                v-for="(item, index) in filterAgentDeployIp"
                :key="index"
                :label="item.ip"
                :value="item.ip"
              ></el-option>
            </el-select>
          </el-col>
          <el-col align="center" :span="1">:</el-col>
          <el-col :span="6">
            <el-form-item prop="logsPort" :rules="rules.agentPort">
              <el-input v-model="formData.logsPort" placeholder="agentLogsPort端口" @input="portInput('logs')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="tips">
            {{validPort('logs').tips}}
          </el-col>
          <el-col align="center" :span="2">
            <el-button type="primary" size="mini" @click="detect(formData.logsIp, formData.logsPort, 'logs')">探测
            </el-button>
          </el-col>
          <el-col align="center" :span="2">
            <i class="el-icon-check" v-if="logsDetectResult == 1" style="color:#67C23A;font-size: 30px;"></i>
            <i class="el-icon-close" v-if="logsDetectResult == 0" style="color:#F56C6C;font-size: 30px;"></i>
          </el-col>
        </el-form-item>
        <el-row style="text-align: center;">
          <el-button type="primary" @click="submitForm('formData')">提 交</el-button>
          <el-button @click="resetForm('formData')">取 消</el-button>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import {Loading} from "element-ui"
  import NetworkItem from './NetworkItem.vue'
  import PortMap from './PortMap.vue'

  export default {
    name: "DeviceEdit",
    components: {NetworkItem, PortMap},
    props: {
      visible: {
        type: Boolean
      },
      id: {
        type: [String, Number]
      }
    },
    data() {
      let validatePort = (rule, value, callback) => {
        const _this = this
        const field = rule.field.split('Port')[0]
        const obj = this.validPort(field)
        const ports = obj ? obj.ports : []
        const range = obj ? obj.portRange : []
        const portMap = obj ? obj.portMap : []
        const val = Number(_this.formData[field + 'Port'])
        let exist = ports.some(p => val == Number(p.value)) ? 1 : 0 //1.存在 0.不存在
        if (exist == 0) {
          for (let r of range) {
            const start = Number(r.start)
            const end = Number(r.end)
            if (val >= start && val <= end) {
              exist = 1
              break
            }
          }
        }
        if (exist == 0) {
          callback(new Error('不在正确范围内'))
        } else {
          // 根据端口协议查看端口是否可用
          if (portMap.length > 0) {
            const item = portMap.filter(pm => pm[obj.type + 'Port'] == value)
            if (item.length > 0 && item[0].protocol == 2) {
              callback(new Error('该端口不支持TCP协议'))
            } else {
              callback()
            }
          } else {
            callback()
          }
          // callback()
        }
      }
      // 网卡基本组成
      return {
        networkCardItem: {
          innerNetwork: {
            ip: "",
            ports: [
              {
                value: ""
              }
            ],
            portRange: [
              {
                start: "",
                end: ""
              }
            ]
          },
          outerNetwork: {
            ip: "",
            ports: [
              {
                value: ""
              }
            ],
            portRange: [
              {
                start: "",
                end: ""
              }
            ]
          },
          portMap: [
            {
              innerPort: "",
              outerPort: ""
            }
          ]
        },
        formData: {
          name: "",
          networkCards: [
            {
              innerNetwork: {
                ip: "",
                ports: [
                  {
                    value: ""
                  }
                ],
                portRange: [
                  {
                    start: "",
                    end: ""
                  }
                ]
              },
              outerNetwork: {
                ip: "",
                ports: [
                  {
                    value: ""
                  }
                ],
                portRange: [
                  {
                    start: "",
                    end: ""
                  }
                ]
              },
              portMap: [
                // {
                //   innerPort: "",
                //   outerPort: "",
                //   protocol: 0
                // }
              ]
            }
          ],
          status: 0,
          deployPort: '',
          exchangePort: '',
          logsPort: '',
        },
        // 设备状态
        statusOption: [
          {
            value: 0,
            label: "正常"
          },
          {
            value: 1,
            label: "不使用"
          }
        ],
        deployDetectResult: -1,
        exchangeDetectResult: -1,
        logsDetectResult: -1,
        rules: {
          "requiredItem": [{required: true, message: '该项是必填项', trigger: 'blur'}],
          "agentPort": [{validator: validatePort, trigger: 'blur'}]
        },
      };
    },
    created() {
      if (this.id) {
        this.dialogTitle = '编辑设备';
        this.getDetail()
      }
    },
    computed: {
      filterAgentDeployIp() {
        let _this = this
        let arr = [];
        let netws = this.formData.networkCards ? this.formData.networkCards : []
        netws.forEach(nw => {
          // if (nw.innerNetwork.ip && !_this.ipExist(nw.innerNetwork.ip, arr)) {
          //   arr.push({
          //     ip: nw.innerNetwork.ip,
          //     ports: nw.innerNetwork.ports,
          //     portRange: nw.innerNetwork.portRange
          //   });
          // }
          // if (nw.outerNetwork.ip && !_this.ipExist(nw.innerNetwork.ip, arr)) {
          //   arr.push({
          //     ip: nw.outerNetwork.ip,
          //     ports: nw.outerNetwork.ports,
          //     portRange: nw.outerNetwork.portRange
          //   });
          // }
          if (nw.innerNetwork.ip) {
            let exist = arr.some(item => item.ip == nw.innerNetwork.ip)
            if (!exist) {
              arr.push({
                type: 'inner',
                ip: nw.innerNetwork.ip,
                ports: nw.innerNetwork.ports,
                portRange: nw.innerNetwork.portRange,
                portMap: nw.portMap
              });
            }
          }
          if (nw.outerNetwork.ip) {
            let exist = arr.some(item => item.ip == nw.outerNetwork.ip)
            if (!exist) {
              arr.push({
                type: 'outer',
                ip: nw.outerNetwork.ip,
                ports: nw.outerNetwork.ports,
                portRange: nw.outerNetwork.portRange,
                portMap: nw.portMap
              });
            }
          }
        });
        return arr;
      },
      validPort() {
        return (type) => {
          let model = {
            ports: [],
            portRange: [],
            tips: ''
          }

          const ip = this.formData[type + 'Ip']
          const obj = this.filterAgentDeployIp.filter(ipObj => ipObj.ip == ip)[0]
          model.ports = obj ? obj.ports : []
          model.portRange = obj ? obj.portRange : []
          model.portMap = obj ? obj.portMap : []
          model.type = obj ? obj.type : ''
          let arr = []
          for (let p of model.ports) {
            p.value !== '' ? arr.push(p.value) : true
          }
          for (let range of model.portRange) {
            if (range.start !== '' && range.end !== '') {
              arr.push(`${range.start}~${range.end}`)
            }
          }
          model.tips = arr.join(',')
          return model
        }
      },
    },
    methods: {
      portInput(type) {
        // this.$forceUpdate()
        this[type + 'DetectResult'] = -1
      },
      // ipExist(ip, arr){
      //   return arr.some(item => item.ip == ip)
      // },
      selectIP(type) {
        this.formData[type + 'Port'] = ''
      },
      // 增加网卡
      addCard() {
        this.formData.networkCards.push(this.networkCardItem);
      },
      // 删除网卡
      delCard(index) {
        this.formData.networkCards.splice(index, 1);
      },
      // 探测 type:{deploy/exchange}
      detect(ip, port, type) {
        let url = 'http://' + ip + ':' + port + '/agent/' + type + '/detect'
        this.$axios.get(url).then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this[type + 'DetectResult'] = 1
          } else {
            this[type + 'DetectResult'] = 0
          }
        }).catch(error => {
          this[type + 'DetectResult'] = 0
          // this.$message({
          //   showClose: true,
          //   message: "系统异常",
          //   type: "error"
          // });
          console.log(error);
        });
      },
      // 获取详情
      getDetail() {
        let loading = Loading.service({
          fullscreen: true,
          text: "数据加载中..."
        });
        this.$axios
          .get(
            this.baseUrl3 +
            "device/findById/" + this.id
          )
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              this.formData = data
            } else {
              this.$message({showClose: true, message: msg, type: "error"});
              console.log(msg);
            }
            loading.close();
          })
          .catch(error => {
            loading.close();
            this.$message({
              showClose: true,
              message: "系统异常",
              type: "error"
            });
            console.log(error);
          });
      },

      /**
       * 提交
       */
      submitForm(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            let loading = Loading.service({
              fullscreen: true,
              text: "数据添加中..."
            });
            let url = this.id ? "device/edit" : "device/add"
            let model = JSON.parse(JSON.stringify(this.formData))
            model.networkCards.forEach(fdata => {
              fdata.innerNetwork.ports = fdata.innerNetwork.ports.filter(
                port => port.value != ""
              )
              fdata.innerNetwork.portRange = fdata.innerNetwork.portRange.filter(
                portR => portR.start != "" && portR.end != ""
              )
              fdata.outerNetwork.ports = fdata.outerNetwork.ports.filter(
                port => port.value != ""
              )
              fdata.outerNetwork.portRange = fdata.outerNetwork.portRange.filter(
                portR => portR.start != "" && portR.end != ""
              )
            })
            this.$axios
              .post(this.baseUrl3 + url, model)
              .then(({data: {msg, code}}) => {
                if (code == 20000) {
                  this.$message({
                    showClose: true,
                    message: "添加成功",
                    type: "success"
                  })
                  this.resetForm(formName);
                } else {
                  this.$message({showClose: true, message: msg, type: "error"});
                  console.log(msg);
                }
                loading.close();
              })
              .catch(error => {
                loading.close();
                this.resetForm(formName);
                this.$message({
                  showClose: true,
                  message: "系统异常，操作失败",
                  type: "error"
                });
                console.log(error);
              });
          } else {
            this.$message({
              showClose: true,
              message: "按照提示输入，确保信息正确且完整",
              type: "warning"
            });
            return false;
          }
        });
      },
      /**
       * 清空
       */
      resetForm(formName) {
        // this.formData = Object.assign(
        //   this.$data.formData,
        //   this.$options.data().formData
        // );
        this.$emit('editCallback')
      },
      // 内外网一致时，可复制内网信息到外网
      copy(nc, index) {
        // nc.outerNetwork = JSON.parse(JSON.stringify(nc.innerNetwork))
        nc.outerNetwork.ip = nc.innerNetwork.ip
        // 遍历内网端口和端口范围，如果在外网中存在，不处理；如果不存在，添加到外网
        if (nc.innerNetwork.portRange) {
          nc.innerNetwork.portRange.forEach(pr => {
            const exist = nc.outerNetwork.portRange.some(outPr => outPr.start == pr.start && outPr.end == pr.end)
            if (!exist) {
              nc.outerNetwork.portRange.push({
                start: pr.start,
                end: pr.end
              })
            }
          })
          nc.outerNetwork.portRange = nc.outerNetwork.portRange.filter(pr => pr.start !== '' && pr.end !== '')
        }
        if (nc.innerNetwork.ports) {
          nc.innerNetwork.ports.forEach(p => {
            const exist = nc.outerNetwork.ports.some(outP => outP.value == p.value)
            if (!exist) {
              nc.outerNetwork.ports.push({
                value: p.value
              })
            }
          })

          nc.outerNetwork.ports = nc.outerNetwork.ports.filter(op => op.value !== '')
        }
        // console.log(nc.outerNetwork)
        this.automap(nc, index)
      },
      renderArr(obj, inOrOut) {
        let arr = []
        let net = obj[inOrOut]
        net.ports.forEach(port => {
          if (port.value === '') {
            return
          }
          arr.push(port.value)
        })
        net.portRange.forEach(pr => {
          if (pr.start === '' || pr.end === '') {
            return
          }
          const start = Number(pr.start)
          const end = Number(pr.end)
          for (let i = start; i <= end; i++) {
            arr.push(i)
          }
        })
        return arr
      },
      automap(nc, index) {
        let iArr = this.renderArr(nc, 'innerNetwork')
        let oArr = this.renderArr(nc, 'outerNetwork')
        let arr = []

        iArr.forEach(inner => {
          const index = oArr.indexOf(inner)
          if (index != -1) {
            arr.push({
              innerPort: inner,
              outerPort: inner,
              protocol: 0
            })
          }
        })
        if (arr.length == 0) {
          arr = [
            {
              innerPort: "",
              outerPort: "",
              protocol: 0
            }
          ]
        }
        this.formData.networkCards[index].portMap = arr

        if (iArr.sort().join(',') != oArr.sort().join(',')) {
          this.$alert('部分端口还未建立映射，请在端口映射中添加！', '提示', {
            confirmButtonText: '确定'
          });
        }
      },
    }
  };
</script>

<style scoped>
  .device >>> .el-form-item__label {
    line-height: 50px;
  }

  .netset {
    border-bottom: 1px dashed #ccc;
    margin-bottom: 10px;
  }

  .titleIcon {
    cursor: pointer;
    /* font-size: 20px; */
    margin-left: 10px;
    order: 2;
  }

  .portDiv {
    margin-bottom: 10px;
  }

  .collapse-title {
    flex: 1 1 auto;
    order: 1;
  }

  .tips {
    font-size: 12px;
    color: #9c9a9a;
  }

  .portmap >>> .el-collapse, .portmap >>> .el-collapse-item__wrap, .portmap >>> .el-collapse-item__header {
    border: none;
  }
</style>
